import { useBackend } from "../../services";

export const useGetSystemStatus = () => {
  const { get } = useBackend();
  const getSystemStatus = async () => {
    return get("systemStatus");
  };
  return { getSystemStatus };
};
